import script from "./Drawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Drawer.vue?vue&type=script&setup=true&lang=ts"

import "./Drawer.vue?vue&type=style&index=0&id=0d327c26&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\33\\Desktop\\2025\\chat\\chat33pro-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d327c26"]])

export default __exports__